import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiError, MessageService } from '../../../../../core';
import { CampanhaFilter } from '../../filter';
import { CampanhaChartsHttpService } from '../services';
import { CampanhaROIChart } from './campanha-roi-chart';

@Component({
    selector: 'sgt-campanha-roi-chart',
    templateUrl: './campanha-roi-chart.component.html',
    styleUrls: ['./campanha-roi-chart.component.less']
})
export class CampanhaROIChartComponent {
    title = 'ROI';
    isLoading: boolean;

    // Campanhas
    chartCampanhas: CampanhaROIChart;
    isEmptyCampanhas: boolean;
    currentRequestCampanhas: Subscription;
    // Pacotes
    currentRequestPacotesCampanhas: Subscription;
    chartPacotesCampanhas: CampanhaROIChart;
    isEmptyPacotesCampanhas: boolean;

    constructor(private messageService: MessageService,
                private campanhaChartsHttpService: CampanhaChartsHttpService) { }


    load(filter: CampanhaFilter) {
        this.isLoading = true;
        Promise.all([
            this.loadCampanhas(filter),
            this.loadPacotesCampanhas(filter)
        ])
        .then(() => this.isLoading = false)
        .catch(() => this.isLoading = false);
    }

    /** Carrega o chart de ROI por Campanhas */
    private loadCampanhas(filter: CampanhaFilter): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.chartCampanhas = null;
            this.isEmptyCampanhas = false;
            this.currentRequestCampanhas?.unsubscribe();
            this.currentRequestCampanhas = this.campanhaChartsHttpService.roi(filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    chart => {
                        this.chartCampanhas = chart;
                        this.isEmptyCampanhas = !this.chartCampanhas || !this.chartCampanhas.entities || this.chartCampanhas.entities.length === 0;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o gráfico de ROI por campanhas');
                        this.isEmptyCampanhas = false;
                        reject();
                    }
                )
        });
    }

    /** Carrega o chart de ROI por Pacotes das Campanhas */
    private loadPacotesCampanhas(filter: CampanhaFilter): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.chartPacotesCampanhas = null;
            this.isEmptyPacotesCampanhas = false;
            this.currentRequestPacotesCampanhas?.unsubscribe();
            this.currentRequestPacotesCampanhas = this.campanhaChartsHttpService.roiPacotes(filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    chart => {
                        this.chartPacotesCampanhas = chart;
                        this.isEmptyPacotesCampanhas = !this.chartPacotesCampanhas || !this.chartPacotesCampanhas.entities || this.chartPacotesCampanhas.entities.length === 0;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o gráfico de ROI por pacotes');
                        this.isEmptyPacotesCampanhas = false;
                        reject();
                    }
                )
        });
    }
}
